/*global Modernizr, mobility_express_rate_directions, mobility_express_tpn_map, mobility_express_fetch_rates, mobility_express_toll_point_data, mobility_express_sum_rates, mobility_express_rate_format_money, console */
/*jslint browser:true */

(function() {
  'use strict';

  var rate_facilities = [],
      directions = {
        'nb': 'Northbound',
        'sb': 'Southbound'
      },
      current_rates_containers = document.querySelectorAll('.js-current-rates');

  // Compile all facilities needed to make a single call
  for (const [index, facility] of Object.entries(mobility_express_tpn_map)) {
    if(!rate_facilities.includes(index)) {
      rate_facilities.push(index);
    }

    for (const [entry_index, entry] of Object.entries(facility)) {
      entry.tollPoints.forEach((tollingPoint, index) => {
        if(typeof tollingPoint === 'object') {
          if(tollingPoint.hasOwnProperty('facility') && !rate_facilities.includes(tollingPoint.facility)) {
            rate_facilities.push(tollingPoint.facility);
          }

          if(tollingPoint.hasOwnProperty('include') && tollingPoint.include.hasOwnProperty('facility') && !rate_facilities.includes(tollingPoint.include.facility)) {
            rate_facilities.push(tollingPoint.include.facility);
          }
        }
      });
    }
  }

  // Fetch all data
  mobility_express_fetch_rates(rate_facilities, get_current_date(), (rates_data) => {
    // Loop over each container to build signs
    current_rates_containers.forEach((current_rates_container) => {
      var rate_facility = current_rates_container.getAttribute('data-facility'),
          facility_rate_directions = mobility_express_rate_directions[rate_facility],
          facility_tpn_map = mobility_express_tpn_map[rate_facility],
          facility_rates_inner_container = current_rates_container.querySelector('.express-rates-container'),
          facility_loading = current_rates_container.querySelector('.current-rates-loading');

      current_rates_container.querySelector('.current-rates-error').classList.add('hidden');

      // Add each direction row
      for (const [direction, rate_directions] of Object.entries(facility_rate_directions)) {
        // Create direction container
        var facility_direction_container = document.createElement('div');
        facility_direction_container.classList.add('current-rate-signs');

        // Create direction heading
        var facility_direction_heading = document.createElement('h3');
        facility_direction_heading.textContent = directions[direction];

        // Create direction entries container
        var roadway_rates_container = document.createElement('div');
        roadway_rates_container.classList.add('current-rate-roadways');

        // Loop over entries
        rate_directions.forEach((rate_direction) => {
          var rate_direction_tpm = facility_tpn_map[rate_direction.value];

          // Create entry row container
          var rate_direction_container = document.createElement('div');
          rate_direction_container.classList.add('current-rate-roadway');

          // Create entry heading
          var rate_direction_heading = document.createElement('h4');
          rate_direction_heading.textContent = 'Entry at ' + rate_direction.name + ' ' + direction.toUpperCase();

          // Create entry sign
          var rate_direction_sign = document.createElement('div');
          rate_direction_sign.classList.add('rate-sign', 'auto-scale', rate_direction_tpm.signClass);

          rate_direction_tpm.tollPoints.forEach((tollingPoint, index) => {
            var tollingPointData,
                tolling_point_is_object = false;

            if(typeof tollingPoint === 'object') {
              tolling_point_is_object = true;

              tollingPointData = tollingPoint;
              tollingPoint = tollingPointData.tollPoint;
            }

            tollingPoint = rates_data.find((include_datum) => include_datum.tollingPointName === tollingPoint);
            if(tollingPoint) {
              var clean = mobility_express_toll_point_data(tollingPoint);

              if(tolling_point_is_object) {
                if(tollingPointData.hasOwnProperty('include')) {
                  var include_point = rates_data.find((include_datum) => include_datum.tollingPointName === tollingPointData.include.tollPoint);
                  if(include_point) {
                    clean = mobility_express_sum_rates(clean, mobility_express_toll_point_data(include_point));
                  }
                }
              }

              rate_direction_sign.insertAdjacentHTML('beforeend', '<div style="color: ' + ((clean.rate === 'CLOSED') ? 'red' : 'white') + ';" class="price-box price-box-' + (index + 1) + '">' + clean.rate + '</div>');
              rate_direction_sign.insertAdjacentHTML('beforeend', '<div style="color: ' + ((clean.pbm === 'CLOSED') ? 'red' : 'white') + ';" class="price-box-pbm price-box-pbm-' + (index + 1) + '">' + clean.pbm + '</div>');
            }
          });

          rate_direction_container.append(rate_direction_heading, rate_direction_sign);
          roadway_rates_container.append(rate_direction_container);
        });

        facility_direction_container.append(facility_direction_heading, roadway_rates_container);
        facility_rates_inner_container.insertBefore(facility_direction_container, facility_loading);
      }

      facility_loading.classList.add('hidden');
    });
  }, () => {
    current_rates_containers.forEach((current_rates_container) => {
      current_rates_container.querySelector('.current-rates-error').classList.remove('hidden');
    });
  });

  function get_current_date() {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();
    let hh = today.getHours();
    let ii = today.getMinutes();

    if (dd < 10) { dd = '0' + dd; }
    if (mm < 10) { mm = '0' + mm; }
    if (hh < 10) { hh = '0' + hh; }
    if (ii < 10) { ii = '0' + ii; }

    // m/d/Y H:i
    return mm + '/' + dd + '/' + yyyy + ' ' + hh + ':' + ii;
  }
}());